import styles from "./hoverEAEmail.scss";
const HoverEAEmail = (props) => {
  let iconClose = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
  return (
    <div className={styles.popUp}>
      <div className={styles.popupContent}>
        <div className={styles.closeIcon}>  <img className={styles.closeIconAlign}
          src={iconClose} onClick={props.handleClose} alt="Close Icon" /></div>
        <div className={styles.contentSpace}>
          {props.preferenceData && props.preferenceData.map(email =>
            <p className={styles.hoverTable}>{email.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c)}</p>
          )
          }
        </div>
      </div>
    </div>
  );
};

export default HoverEAEmail;
